import "reflect-metadata";
import { BattleUIScene } from "./uis/scenes/battle/battle-ui";
import { BattleScene } from "./uis/scenes/battle/side-battle-scene";
import { BootScene } from "./uis/scenes/boot";
import { DialogScene } from "./uis/scenes/dialogs/dialog-scene";
import { InfoLayerScene } from "./uis/scenes/info-layer/info-layer-scene";
import { InventoryScene } from "./uis/scenes/menus/inventory-scene";
import { ItemShopBuyScene } from "./uis/scenes/menus/item-shop-buy-scene";
import { MenuScene } from "./uis/scenes/menus/menu-scene";
import { LoadGameScene } from "./uis/scenes/menus/start-menu/load-game-scene";
import { LoginScene } from "./uis/scenes/menus/start-menu/login-scene";
import { NewGameScene } from "./uis/scenes/menus/start-menu/new-game-scene";
import { TitleMenuScene } from "./uis/scenes/menus/start-menu/title-menu-scene";

/**
 * possibly redudant with some inner capabilities of Phaser ; to check
 */
export class GameOptions {
    public screenWidth;
    public screenHeight;
    public zoom;
}

export class SimpleGame {
    private game: Phaser.Game;
    private config: Phaser.Types.Core.GameConfig;

    // Default project ID for single-project deployment
    private static DEFAULT_PROJECT_ID = "695bbdd0ff1320fcba304e46";

    /**
     * Get the current project ID.
     * Checks URL query parameter (?projectId=xxx) first, falls back to default.
     */
    public static get PROJECT_ID(): string {
        const urlParams = new URLSearchParams(window.location.search);
        const projectIdParam = urlParams.get("projectId");
        return projectIdParam || SimpleGame.DEFAULT_PROJECT_ID;
    }

    public static GAME_DEFINITION_ID = 0; // Deprecated, kept for compatibility

    // Local storage for UI/debugging - backend uses session-based save management
    // Type changed from number to string (save_id instead of game_id)
    // Note: After load_game_request, save_id is stored in backend WebSocket session
    public static CURRENT_GAME: string = null; // Changed from: number = -1

    public static CURRENT_MAP_ID: string;

    public static GAME_OPTIONS = {
        screenWidth: 540,
        screenHeight: 400,
        zoom: 2,
    };

    constructor() {
        this.config = {
            type: Phaser.CANVAS,
            parent: "content",
            width: SimpleGame.GAME_OPTIONS.screenWidth,
            height: SimpleGame.GAME_OPTIONS.screenHeight,
            zoom: SimpleGame.GAME_OPTIONS.zoom,
            pixelArt: true,
            physics: {
                default: "arcade",
                arcade: {
                    gravity: { x: 0, y: 0 },
                    debug: true, // set to true to view zones
                },
            },
            scene: [
                BootScene,
                LoginScene,
                BattleScene,
                BattleUIScene,
                InfoLayerScene,
                DialogScene,
                MenuScene,
                InventoryScene,
                ItemShopBuyScene,
                TitleMenuScene,
                LoadGameScene,
                NewGameScene,
            ],
        } as Phaser.Types.Core.GameConfig;
    }

    public start() {
        this.game = new Phaser.Game(this.config);
    }
}

const game = new SimpleGame();
game.start();
